import { DollarSign, ShieldAlert, Scale, Zap } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const features = [
  {
    icon: DollarSign,
    title: 'Revenue Recovery',
    body: 'Capture legitimate procedure revenue that is currently lost to downcoding and authorization mismatches.',
  },
  {
    icon: ShieldAlert,
    title: 'Denial Prevention',
    body: 'By reconciling documentation before export, we eliminate the primary triggers for payer denials.',
  },
  {
    icon: Scale,
    title: 'Risk Mitigation',
    body: 'Transfer operational and compliance risk. LINK provides a full audit trail (Evidence Snippets) for every CPT code exported.',
  },
  {
    icon: Zap,
    title: 'HIM/Billing Acceleration',
    body: 'Deliver "Epic-ready" clean bundles to your billing team, reducing their manual review time by up to 80%.',
  },
];

export function HealthSystemSegment() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
          Institutional Governance for Procedure Revenue.
        </h2>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
          Stop leaking earned revenue. LINK provides a defensible, automated
          enforcement layer that protects the hospital's bottom line while
          ensuring 100% compliance.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {features.map((feat) => (
          <Card
            key={feat.title}
            className="bg-card border border-border rounded-xl transition-all hover:shadow-lg"
          >
            <CardContent className="p-8">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 mb-5">
                <feat.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {feat.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feat.body}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
